module.exports = __webpack_public_path__ + "static/media/crm_upload_template.6e522266.xlsx";